import React from 'react'

import logo from '../assets/Logo.png'
import COLORS from '../styles/colors'

const Header = ({ textComponent }) => {
  return (
    <div style={styles.header}>
      <img style={styles.logo} src={logo} alt='Mellro' />
      {textComponent}
    </div>
  )
}

const styles = {
  header: {
    height: 110,
    padding: '24px 32px',
    backgroundColor: COLORS.brand.primary,
    color: COLORS.greyscale.white,

    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    width: 68,
    height: 'auto',
    marginRight: 33,
  },
}

export default Header
